<template>
  <v-card
    outlined
    tile
    elevation="0"
    class="pa-10">
    <div class="_fs-24">
      QR Code
    </div>
    <v-form @submit.prevent="onSubmit">
      <div
        id="container-button-payment"
        class="text-center pa-16"
      />
    </v-form>
  </v-card>
</template>
<script>
import { mapWaitingActions } from 'vue-wait'
import { mapActions, mapState } from 'vuex'
import configuration from '@/config'
import { roundDecimalDigits } from '@/utils/currency'

export default {
  name: 'BasePaymentQRCode',
  props: {
    orderResult: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      initialButtonKPayment: false
    }
  },
  computed: {
    ...mapState('User', ['userProfile'])
  },
  watch: {
    orderResult: {
      deep: true,
      handler() {
        if (
          !this.initialButtonKPayment
          && this.orderResult
          && typeof this.orderResult === 'object'
          && Object.values(this.orderResult).length) {
          this.createButtonKPayment()
        }
      }
    }
  },
  created() {
    this.$wait.start('app loading')
  },
  async mounted() {
    if (
      this.orderResult
      && typeof this.orderResult === 'object'
      && Object.values(this.orderResult).length) {
      this.createButtonKPayment()
    }
  },
  methods: {
    ...mapActions({
      createOrder: 'Payment/createOrder'
    }),
    ...mapWaitingActions('Payment', {
      createOrder: 'app loading'
    }),
    async createButtonKPayment() {
      try {
        this.initialButtonKPayment = true

        const attributes = {
          amount: roundDecimalDigits(this.orderResult.netTotal),
          currency: 'THB',
          description: 'Line Services by Sellsuki',
          source_type: 'qr',
          reference_order: this.orderResult._id,
          metadata: this.orderResult?.orderItems?.map((item) => ({
            item: item.productName,
            qty: item.itemQty,
            amount: item.itemAmount
          })),
          ref_1: this.orderResult.code
        }

        if (this.userProfile?.kpayment) {
          attributes.customer = {
            customer_id: this.userProfile.kpayment?.customerId
          }
        }

        await this.createOrder(attributes)
          .then((response) => {
            if (response.status === 'success') {
              const script = document.createElement('script')

              script.setAttribute('type', 'text/javascript')
              script.setAttribute('src', configuration.K_PAYMENT_URL)
              script.setAttribute('data-apikey', configuration.K_PAYMENT_API_KEY)
              script.setAttribute('data-amount', response.amount)
              script.setAttribute('data-payment-methods', response.source_type)
              script.setAttribute('data-order-id', response.id)
              script.setAttribute('data-name', 'LINE By Sellsuki')

              script.onload = () => {
                const payButtons = document.getElementsByClassName('pay-button')

                if (payButtons.length === 0) {
                  window.KPayment.create()
                }
              }

              document.getElementById('container-button-payment').append(script)
            } else {
              this.$swal({
                title: 'มีบางอย่างผิดพลาด',
                text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
                icon: 'error'
              })
            }
          })
          .catch(() => {
            this.$swal({
              title: 'มีบางอย่างผิดพลาด',
              text: 'กรุณาทดลองใหม่ หรือติดต่อเจ้าหน้าที่',
              icon: 'error'
            })
          })
          .finally(() => {
            this.$wait.end('app loading')
          })
      } catch {
        this.initialButtonKPayment = false
      }
    },
    onSubmit() {
      this.$router.push({
        name: 'UploadSlipSuccess',
        params: {
          order: this.orderResult
        }
      })
    }
  }
}
</script>
